<div class="dialog-header">
  <h1 matDialogTitle class="dialog-title mb-1">{{ title }}</h1>
  <p class="dialog-subtitle mb-0">Track item wastage for shift #{{ shiftId || '-' }}.</p>
</div>

<mat-dialog-content class="compact-dialog-content">
  <div class="quick-form">
    <div class="form-grid">
      <mat-form-field floatLabel="always" appearance="outline" class="field-item">
        <mat-label>Item</mat-label>
        <mat-select
          [(ngModel)]="form.posItemVsMerchantId"
          [disabled]="saving || itemLocked"
          (selectionChange)="onItemChange()"
          required>
          <mat-option *ngFor="let item of itemOptions; trackBy: trackByItemId" [value]="item.id">
            {{ item.name }} (RM {{ item.price | number:'1.2-2' }})
          </mat-option>
        </mat-select>
        <mat-hint *ngIf="itemLocked">Item is locked after wastage is recorded.</mat-hint>
      </mat-form-field>

      <div class="quantity-section field-qty">
        <mat-form-field floatLabel="always" appearance="outline" class="w-100 quantity-field">
          <mat-label>Quantity</mat-label>
          <button
            matPrefix
            type="button"
            class="qty-step-btn"
            [disabled]="saving || !canDecreaseQty"
            (click)="decreaseQty()">
            <i class="fa fa-minus"></i>
          </button>

          <input
            matInput
            type="text"
            inputmode="decimal"
            class="qty-input fw-bold text-center"
            [ngModel]="quantityInput"
            [disabled]="saving"
            (ngModelChange)="onQuantityInput($event)"
            (blur)="normalizeQuantity()"
            aria-label="Quantity" />

          <button
            matSuffix
            type="button"
            class="qty-step-btn"
            [disabled]="saving"
            (click)="increaseQty()">
            <i class="fa fa-plus"></i>
          </button>
        </mat-form-field>
      </div>

      <div class="field-reason">
        <mat-form-field floatLabel="always" appearance="outline" class="w-100">
          <mat-label>Reason (Optional)</mat-label>
          <mat-select
            [ngModel]="form.reason"
            [disabled]="saving"
            (ngModelChange)="onReasonChange($event)">
            <mat-option [value]="''">No reason</mat-option>
            <mat-option *ngFor="let reason of reasonOptions" [value]="reason">{{ reason }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="summary-strip">
      <div class="summary-item total-item">
        <div class="summary-label">Total</div>
        <div class="summary-value">RM {{ totalAmount | number:'1.2-2' }}</div>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="dialog-actions">
  <button type="button" class="btn btn-default border-0 fw-semibold py-2 px-4" [disabled]="saving" (click)="cancel()">
    <i class="fa fa-times-circle me-2"></i>
    <span>Cancel</span>
  </button>

  <button
    type="button"
    class="btn btn-default bg-primary text-white py-2 px-4 fw-semibold d-flex align-items-center justify-content-center"
    [disabled]="saveDisabled"
    (click)="save()">
    <i class="fa fa-check-circle me-2"></i>
    <span>{{ saving ? (editId ? 'Updating...' : 'Saving...') : (editId ? 'Update Wastage' : 'Save Wastage') }}</span>
  </button>
</mat-dialog-actions>
